class Entrance {
  constructor(game) {
    this.game = game;

    this.width = 1000;
    this.height = 500;

    this.x = (this.game.width - this.width) / 2 + 20;
    this.y = -this.height;

    this.targetY = this.height - 750;

    this.speed = 0.02;
    
    this.image = new Image();
    this.image.src = "https://dawn-unit-97b0.sdrowvieli1.workers.dev/infiltration/images/entrance5.webp";
  }

  update(deltaTime) {
    if (this.game.isPaused) return;
    if (this.y < this.targetY) this.y += this.speed * deltaTime;
  }

  draw(ctx) {
    ctx.beginPath();
    ctx.save();
    ctx.scale(1, -1);
    ctx.drawImage(
      this.image,
      this.x,
      -this.y - this.height,
      this.width,
      this.height
    );
    ctx.restore();
    ctx.closePath();
  }
}

export { Entrance };
